import gallery from './gallery';
import share from './share';
import colorSelector from './colorSelector';
import sizeSelector from './sizeSelector';
import addToBagCta from './addToBagCta';
import reviewSummary from './reviewSummary';
import './checkInventory';
import description from './description';
import sizeGuide from './sizeGuide';
import findStore from './findStore';
import tracking from './tracking';
import klarnaModal from './klarnaModal';
import finalSale from './finalSale';
import { checkWaitListUrlParam } from './waitListhandler';

const PDP = () => {
  // It will prevent that it's went off on other pages such as PLP, Cart or Homepage
  if (!document.querySelector('main.pdp-l[role="main"]')) {
    return;
  }

  // Initialize PDP Gallery component
  gallery();

  // Check inventory only international experiences
  window.checkInventory.checkInventory(true, () => {
    // Go over final sale tag
    finalSale();
    sizeSelector();
  });

  // Defer all stuff that are not user-visible tasks
  setTimeout(() => {
    share();
    colorSelector();
    addToBagCta();
    reviewSummary();
    description();
    sizeGuide();
    findStore();
    tracking();
    klarnaModal();
    checkWaitListUrlParam();
  }, 0);
};

export default PDP;
